// Each file here is tied to the routes defined in the routes folder.
// All API calls originating from that page can be put here

/* eslint-disable no-undef */
import { generatePath } from 'react-router-dom';
import { axiosInstance } from '../common';

// Define all api endpoint urls at the top
const ENDPOINT_SEARCH = '/product/search';
const ENDPOINT_PRODUCT = '/product/:id';
const ENDPOINT_PRODUCT_ACTION = '/product/:id/:action';


// Define all api functions here
// Paged search: first page holds the top `limit` hits, `hasMore` tells the
// caller whether scrolling should load the next page.
export async function searchProducts(query, category_id, language_code, page = 1, limit = 10) {
    return axiosInstance.get(ENDPOINT_SEARCH, { params: { q: query, category_id, lang: language_code, page, limit } })
        .then((response) => ({
            // A CMS hit not in the ERP yet has no `id`: its value is `cms:<cms id>`
            // and it is imported when picked (importCmsProduct).
            options: (response.data || []).map(({ id, cms_id, name, photo, starting_price, is_erp_product }) => ({
                label: name,
                value: id ?? `cms:${cms_id}`,
                cms_id,
                photo,
                starting_price,
                is_erp_product: Boolean(is_erp_product),
            })),
            hasMore: Boolean(response.has_more),
        }))
}

// `sync: true` refreshes the product from the CMS first — only for the moment a
// product is picked in the product search; all other reads come from the ERP.
export const getProductDetails = async (id, language, content_language = null, { sync = false } = {}) => {
    return axiosInstance.get(generatePath(ENDPOINT_PRODUCT, {
        id
    }), {
        params: {
            lang: language,
            ...(content_language && { content_lang: content_language }),
            ...(sync && { sync: 1 }),
        }
    }).then(({ data }) => data)
}

export const getProductVendors = (productId) => {
    return axiosInstance.get(generatePath(ENDPOINT_PRODUCT_ACTION, {
        id: productId,
        action: 'vendor'
    })).then(({ data }) => data)
}

export const assignVendorToProduct = (productId, vendorId, language = null) => {
    return axiosInstance.post(generatePath(ENDPOINT_PRODUCT_ACTION, {
        id: productId,
        action: 'vendor'
    }), {
        vendor_id: vendorId,
        ...(language && { language })
    }).then(({ data }) => data)
}

export const removeVendorFromProduct = (productId, vendorId) => {
    return axiosInstance.post(generatePath(ENDPOINT_PRODUCT_ACTION, {
        id: productId,
        action: 'vendor-remove'
    }), {
        vendor_id: vendorId,
    }).then(({ data }) => data)
}